import React from 'react';
import { ResponsiveAutocomplete } from '@/components/selects/ResponsiveAutocomplete';
import { USER_IMPORT_STATUSES } from '../../users/api/userImportsApi';

const OPTIONS = [
	{ id: USER_IMPORT_STATUSES.queued, name: 'Queued' },
	{ id: USER_IMPORT_STATUSES.running, name: 'Running' },
	{ id: USER_IMPORT_STATUSES.finished, name: 'Finished' },
	{ id: USER_IMPORT_STATUSES.failed, name: 'Failed' },
];

/**
 * Pick import statuses, for the import history's Status filter. value/onChange are a list
 * of statuses. Other props go to ResponsiveAutocomplete.
 */
export const ImportStatusPicker = (props) => (
	<ResponsiveAutocomplete options={OPTIONS} multiple {...props} />
);
